import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import colorConfigs from "../../../../configs/colorConfigs";
import { ExpensesList } from "./ExpensesList";
import { AddExpense } from "./AddExpense";

const filterItems = [
    {
        id: 0,
        label: "Expense Name",
    },
    {
        id: 1,
        label: "Expense Type Name",
    }
]

type ExpenseProps = {
    idNumber: any
}

export const Expenses = ({
    idNumber
}: ExpenseProps) => {
    const { themeStyles } = useTheme();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [expenseFilterValue, setExpenseFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [openAddExpense, setOpenAddExpense] = useState<boolean>(false);
    const [refreshExpenseList, setRefreshExpenseList] = useState<boolean>(false);

    useEffect(() => {
        if (refreshExpenseList) {
            setPaginationModel({
                page: 0,
                pageSize: 10,
            })
            setSearchValue("");
            setRefreshExpenseList(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshExpenseList])

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full`}>

                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => setOpenAddExpense(true)}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Expense</span>
                        </button>
                    </div>
                </div>
                <div>
                    <ExpensesList
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        expenseFilterValue={expenseFilterValue}
                        setExpenseFilterValue={setExpenseFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                        idNumber={idNumber}
                        setRefreshExpenseList={setRefreshExpenseList}
                    />
                </div>
            </div>
            {
                openAddExpense && (
                    <AddExpense
                        idNumber={idNumber}
                        openAddExpense={openAddExpense}
                        setOpenAddExpense={setOpenAddExpense}
                        setRefreshExpenseList={setRefreshExpenseList}
                    />
                )
            }
        </>

    )
}